<div
	class="inline-flex cursor-default"
	[class.cursor-pointer]="sections.length > 0"
	cdkOverlayOrigin
	#trigger="cdkOverlayOrigin"
	#triggerEl
	(mouseenter)="show()"
	(mouseleave)="hide()"
	aria-haspopup="true"
	[attr.aria-expanded]="isOpen">
	<ng-content></ng-content>
</div>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen" [cdkConnectedOverlayPositions]="positions">
	<div
		class="z-[1000] m-0 max-h-[400px] max-w-[360px] overflow-x-hidden overflow-y-auto rounded-lg border border-gray-200 bg-white p-4 shadow-lg pointer-events-auto"
		[@transformPopover]
		(mouseenter)="show()"
		(mouseleave)="hide()">
		@for (section of sections; track $index) {
			@switch (section.type) {
				@case (PopoverSectionType.TEXT) {
					@for (item of section.items; track $index; let isLast = $last) {
						<p class="text-xs leading-4 text-gray-700" [class.mb-2]="!isLast">{{ item }}</p>
					}
				}
				@case (PopoverSectionType.LIST) {
					<ul class="list-disc pl-5 text-xs leading-4 text-gray-700" [class.mb-2]="!$last">
						@for (item of section.items; track $index; let isLast = $last) {
							<li [class.mb-1]="!isLast">{{ item }}</li>
						}
					</ul>
				}
				@case (PopoverSectionType.TABLE) {
					<table class="w-full border-collapse text-xs text-gray-700" [class.mb-2]="!$last">
						@if (section.headers?.length) {
							<thead>
								<tr>
									@for (header of section.headers; track $index) {
										<th
											class="border-b border-black/10 px-2 py-1 text-left text-[11px] font-semibold uppercase tracking-[0.02em] text-gray-500">
											{{ header }}
										</th>
									}
								</tr>
							</thead>
						}
						<tbody>
							@for (row of section.rows ?? []; track $index) {
								<tr>
									@for (cell of row; track $index) {
										<td class="border-b border-black/5 px-2 py-1 last:border-b-0">{{ cell }}</td>
									}
								</tr>
							}
						</tbody>
					</table>
				}
			}
		}
	</div>
</ng-template>
